import React from "react";

export const APP_VERSION = "0.3.0 · Phase 3";

export const Footer = () => {
  return (
    <footer
      data-testid="app-footer"
      className="border-t border-navy/10 bg-white px-6 py-3 flex items-center justify-between text-[11px] uppercase tracking-wider2 text-navy/45 font-sans"
    >
      <span>Newton Campus Garching · Investoren-Akquise-Dashboard</span>
      <span data-testid="app-version">v{APP_VERSION}</span>
    </footer>
  );
};
